import { colors } from "./Variables";

export const extraCssText = `padding: 0;
margin:0;
white-space: unset;
background-color: transparent;
filter: drop-shadow(0px 5px 5px ${colors.black});
border-radius: 0; font: 10px / 1.5 Montserrat;`;

export const getToolBox = (color: string) => {
  return {
    iconStyle: {
      borderColor: color,
    },
    right: 0,
    feature: {
      dataZoom: {
        emphasis: {
          iconStyle: {
            textFill: colors.white,
          },
        },
        title: {
          zoom: "highlight and zoom",
          back: "go back one step",
        },
        yAxisIndex: "none",
      },
      restore: {
        emphasis: {
          iconStyle: {
            textFill: colors.white,
          },
        },
        title: "restore",
      },
    },
  };
};
